import KeyValueListDisplay from '@/components/KeyValueDisplay';
import { convertISODateToMMDDYYYY, convertISOToTime, displayFullName, formatPhoneNumber } from '@/lib/utils';
import { VendorResponse, VendorStatus } from '@/types/vendor.types';

const VendorDetailsContent = ({ vendorData }: { vendorData: VendorResponse | undefined }) => {
  const primaryVendorDetails = [
    {
      label: 'Phone Number',
      value: formatPhoneNumber(vendorData?.phone) ?? '-',
    },
    {
      label: 'Email Address',
      value: vendorData?.email ?? '-',
    },
    {
      label: 'Tax ID',
      value: vendorData?.taxId ?? '-',
    },
    ...(vendorData?.status === VendorStatus.INACTIVE
      ? [
          {
            label: 'Deactivated On',
            value: vendorData?.deactivatedAt
              ? `${convertISODateToMMDDYYYY(vendorData.deactivatedAt)} ${convertISOToTime(vendorData.deactivatedAt)}`
              : '-',
          },
          {
            label: 'Deactivated By',
            value: vendorData?.deactivatedBy ? displayFullName(vendorData.deactivatedBy) : '-',
          },
        ]
      : []),
  ];
  const secondaryVendorDetails = [
    {
      label: 'Fees',
      value: vendorData?.fees ? '$' + vendorData?.fees : '-',
    },
    {
      label: 'Notes',
      value: vendorData?.notes ?? '-',
    },
  ];
  const coverageAreaDetails = [
    {
      label: 'Zip Codes',
      value: vendorData?.coverageAreas.join(', ') ?? '-',
    },
    {
      label: 'Counties',
      value: vendorData?.counties?.length ? vendorData.counties.join(', ') : '-',
    },
  ];
  return (
    <div className="flex flex-col gap-6 w-full py-6 text-sm">
      <div className="flex flex-col gap-2">
        <KeyValueListDisplay data={primaryVendorDetails} />
      </div>
      <hr />
      <div className="flex flex-col gap-4">
        <KeyValueListDisplay data={secondaryVendorDetails} />
      </div>
      <hr />
      <div className="flex flex-col gap-2">
        <span className="font-semibold text-base">Coverage Area</span>
        <KeyValueListDisplay data={coverageAreaDetails} />
      </div>
    </div>
  );
};

export default VendorDetailsContent;
